import React, { useCallback } from 'react';
import { FormControl, useFormField, FieldProps } from '@core/utils/form';
import { Label, FormGroup } from 'reactstrap';
import FormHelperText from '@mui/material/FormHelperText';

import { toMoment, TimeInput } from '@core/utils/time';

import { DayPickerRangeControllerShape } from 'react-dates';
import moment from 'moment';
import { Calendar, CalendarProps, theme } from 'antd';

import type { Moment } from 'moment';
import momentGenerateConfig from 'rc-picker/es/generate/moment';
const MomentCalendar = Calendar.generateCalendar<Moment>(momentGenerateConfig);
export interface FormDateInlineProps extends FieldProps<FormControl<number>> {
  options?: Partial<DayPickerRangeControllerShape>;
  minDate?: TimeInput;
  maxDate?: TimeInput;
  onChange?(date: number): void;
  numberOfMonths?: number;
  useUtc?: boolean;
}

export function FormDateInline(props: FormDateInlineProps) {
  const { formControl, fieldState, fieldConfig } = useFormField(props);
  const { useUtc = true } = props;
  const fieldTouched = (fieldState && fieldState.touched) || formControl.inheritedSubmitted || false;
  const fieldValue = fieldState.value ? toMoment(fieldState.value, { utc: useUtc }) : null;
  const fieldError = (fieldTouched && fieldState.errorMessage) || null;

  const fieldDisabled = fieldConfig.disabled || false;

  const handleChange = useCallback(
    (date: Moment | null) => {
      if (date) {
        if (useUtc) {
          const m = moment.utc(date.format('YYYY-MM-DD')).add(12, 'h');
          formControl.setValue(m.unix());
          props.onChange && props.onChange(m.unix());
        } else {
          formControl.setValue(date.endOf('day').unix());
          props.onChange && props.onChange(date.endOf('day').unix());
        }
      }
    },
    [formControl, props, useUtc],
  );

  const isDayBlocked = useCallback(
    (m: moment.Moment) => {
      if (props.minDate) {
        return m.isBefore(toMoment(props.minDate).startOf('day').subtract(1, 'h'));
      }
      if (props.maxDate) {
        return m.isAfter(toMoment(props.minDate).endOf('day').add(1, 'h'));
      }
      return false;
    },
    [props.maxDate, props.minDate],
  );

  const { token } = theme.useToken();

  const wrapperStyle: React.CSSProperties = {
    border: `1px solid ${token.colorBorderSecondary}`,
    borderRadius: token.borderRadiusLG,
    width: 300,
  };

  return (
    <FormGroup className="theme_date-picker">
      {fieldConfig.label && <Label for={formControl.uid}>{fieldConfig.label}</Label>}
      <div style={wrapperStyle}>
        <MomentCalendar
          mode="month"
          fullscreen={false}
          defaultValue={fieldValue}
          onSelect={(v, s) => s.source === 'date' && handleChange(v)}
          disabledDate={date => {
            if (props.minDate) {
              return date.isBefore(toMoment(props.minDate).startOf('day').subtract(1, 'h'));
            }
            if (props.maxDate) {
              return date.isAfter(toMoment(props.minDate).endOf('day').add(1, 'h'));
            }
            return false;
          }}
        />
      </div>
      {/* <DayPickerRangeController
        {...props.options}
        startDate={fieldValue}
        endDate={fieldValue}
        isDayBlocked={isDayBlocked}
        isOutsideRange={() => false}
        onDatesChange={({ startDate, endDate }) => handleChange(startDate)}
        focusedInput="startDate"
        onFocusChange={() => R.noop()}
        isFocused={formControl.focused}
        disabled={fieldDisabled}
        numberOfMonths={props.numberOfMonths || 1}
        hideKeyboardShortcutsPanel
        initialVisibleMonth={() => fieldValue || toMoment()}
      /> */}
      {!!fieldError && (
        <FormHelperText className="mui-error" style={{ color: '#f44336' }}>
          {fieldError}
        </FormHelperText>
      )}
    </FormGroup>
  );
}
